<ng-container *ngIf="permConfig.isViewAllowed">

    <div class="container-fluid">
        <app-page-title title="Vendor Reconciliation"></app-page-title>
        <form [formGroup]="vendorReconciliationForm">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="InvoiceNo" class="form-label">Invoice No.<span
                                            class="mandatory">*</span></label>
                                        <input type="text" formControlName="txtInvoiceNo"
                                            class="form-control form-control-sm" id="InvoiceNo"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorReconciliationForm.get('txtInvoiceNo')?.touched) && vendorReconciliationForm.get('txtInvoiceNo').errors}" >
                                        <div *ngIf="(isFormSubmitted || vendorReconciliationForm.get('txtInvoiceNo')?.touched) && vendorReconciliationForm.get('txtInvoiceNo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorReconciliationForm.get('txtInvoiceNo').errors.pattern">Maximum upto 15
                                                digits allowed.</span>
                                                <span *ngIf="vendorReconciliationForm.get('txtInvoiceNo').errors.required">Invoice number is
                                                    Required</span>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="invoiceDate" class="form-label">Invoice Date <span
                                                class="mandatory">*</span></label>
                                        <input id="invoiceDate" class="form-control form-control-sm" type="date"
                                            placeholder="Select" formControlName="txtInvoiceDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorReconciliationForm.get('txtInvoiceDate')?.touched) && vendorReconciliationForm.get('txtInvoiceDate').errors}" >
                                        <div *ngIf="(isFormSubmitted || vendorReconciliationForm.get('txtInvoiceDate')?.touched) && vendorReconciliationForm.get('txtInvoiceDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorReconciliationForm.get('txtInvoiceDate').errors.required">Invoice Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label class="form-label" for="vendor">Vendor <span
                                            class="mandatory">*</span></label>
                                        <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                            bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorReconciliationForm.get('ddlVendor')?.touched) && vendorReconciliationForm.get('ddlVendor').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || vendorReconciliationForm.get('ddlVendor')?.touched) && vendorReconciliationForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="vendorReconciliationForm.get('ddlVendor').errors.required">Vendor is
                                            Required</span>
                                    </div>
        
                                    </div>
                                </div>
        
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="format" class="form-label">Format</label>
                                        <ng-select id="format" [items]="formatList" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlFormat" (change)="onChangeFormatType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorReconciliationForm.get('ddlFormat')?.touched) && vendorReconciliationForm.get('ddlFormat').errors}" ></ng-select>

                                            <div *ngIf="(isFormSubmitted || vendorReconciliationForm.get('ddlFormat')?.touched) && vendorReconciliationForm.get('ddlFormat').errors"
                                                class="invalid-feedback">
                                             <span *ngIf="vendorReconciliationForm.get('ddlFormat').errors.required">Format is
                                            Required</span>
                                    </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="showDownloadBtn">
                                    <div class="col-md-2">
                                        <label class="form-label mb-0"></label>
                                        <div class="">
                                            <button type="button" class="btn btn-primary btn-sm d-flex"
                                                (click)="downloadFormatFile()" >
                                                <i class="bx bx-download font-size-15 me-1"></i> Download
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label"></label>
                                    <div class="input-group">
                                        <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls"
                                            formControlName="fileControl" (change)="onChangeFileSelect($event)"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || vendorReconciliationForm.get('fileControl').touched) && vendorReconciliationForm.get('fileControl').errors}" >
                                        <button type="submit" class="btn btn-primary btn-sm d-flex"  (click)="uploadDocument();" >
                                            <i class="bx bx-upload font-size-15 me-1"></i> Upload
                                        </button>
                                        <div *ngIf="(isFormSubmitted || vendorReconciliationForm.get('fileControl').touched) && vendorReconciliationForm.get('fileControl').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="vendorReconciliationForm.get('fileControl').errors.required">Select file
                                                to upload</span>
                                        </div>
                                    </div>
                                    <div *ngIf="showLogoProgressBar" class="progress mt-2">
                                        <div class="progress-bar progress-bar-striped" role="progressbar"
                                            [style.width.%]="logoProgress" [attr.aria-valuenow]="logoProgress" aria-valuemin="0"
                                            aria-valuemax="100">
                                            {{logoProgress}}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Vendor Reconciliation</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefsPeriod"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReadyPeriod($event)"
                                [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="showRateDetails">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Vendor Reconciliation Details</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowVendorDetailData" [columnDefs]="columnDefs"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                                [gridOptions]="gridOptions">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>